import { ProductLabelInfoForm } from "../edit-product/product-label-info-form";

export class CreateProductValidator {
  private errorMessage: string;

  constructor(private form: ProductLabelInfoForm) {}

  public isFormValid(): boolean {
    if (!this.form.getFormGroup().value.ean1) {
      this.errorMessage = "O produto cadastrado deve conter ao menos um EAN";
    } else if (!this.form.getFormGroup().value.productName) {
      this.errorMessage = "O campo Produto é obrigatório";
    } else if (!this.form.getFormGroup().value.presentation) {
      this.errorMessage = "O campo Apresentação é obrigatório";
    } else if (!this.form.getFormGroup().value.substance) {
      this.errorMessage = "O campo Substância é obrigatório";
    } else if (!this.form.getFormGroup().value.laboratory) {
      this.errorMessage = "O campo Laboratório é obrigatório";
    } else if (!this.form.getFormGroup().value.fiscalNumber) {
      this.errorMessage = "O campo CNPJ é obrigatório";
    } else if (!this.form.getFormGroup().value.productType) {
      this.errorMessage = "O campo Tipo do Produto é obrigatório";
    } else if (!this.form.getFormGroup().value.productSubType) {
      this.errorMessage = "O campo Sub Tipo do Produto é obrigatório";
    } else if (!this.form.getFormGroup().value.therapeuticClass) {
      this.errorMessage = "O campo Classe Terapêutica é obrigatório";
    } else if (!this.form.getFormGroup().value.productUseValidity) {
      this.errorMessage = "O campo Tipo de Validade é obrigatório";
    } else if (!this.form.getFormGroup().value.priceRegime) {
      this.errorMessage = "O campo Regime de Preço é obrigatório";
    } else if (!this.form.getFormGroup().value.useType) {
      this.errorMessage = "O campo Tipo de Uso é obrigatório";
    } else if (!this.form.getFormGroup().value.tributaryCreditConcession) {
      this.errorMessage = "O campo Concessão de Crédito Tributário é obrigatório";
    } else if (!this.form.getFormGroup().value.GGREMCode) {
      this.errorMessage = "O campo GGREM é obrigatório";
    } else if (!this.form.getFormGroup().value.registry) {
      this.errorMessage = "O campo Registro é obrigatório";
    }
    return !this.errorMessage;
  }

  public getErrorMessage(): string {
    return this.errorMessage;
  }
}
